import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchCustomer } from '../../../api';

export const coreCustomersByIdPatchSlice = createPatchAsyncSlice({
	name: 'CoreCustomersById',
	receive: true,
	request: true,
	requestHandler: patchCustomer,
	retainDataOnRequest: false
});
